import { render, staticRenderFns } from "./rich-text-previewer.vue?vue&type=template&id=67602e4a&scoped=true"
import script from "./rich-text-previewer.ts?vue&type=script&lang=ts&external"
export * from "./rich-text-previewer.ts?vue&type=script&lang=ts&external"
import style0 from "./rich-text-previewer.less?vue&type=style&index=0&id=67602e4a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67602e4a",
  null
  
)

export default component.exports